import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";

import BasicModal from "@/components/basic-modal";
import UITextField from "@/components/ui-controls/textfield";
import ColorPicker from "@/components/ui-controls/color-picker";
import { useEffect } from "react";

const AddTagModal = ({
  openModal,
  handleClose,
  loading,
  onChangeSubmit,
  tagName,
  setTagName,
  tagColor,
  setTagColor,
  colorOptions,
}) => {
  useEffect(() => {
    if (!tagColor) {
      if (colorOptions && colorOptions?.[0]) {
        setTagColor(colorOptions?.[0]?.id);
      }
    }
  }, [tagColor]);

  return (
    <BasicModal
      open={openModal}
      title={"Create a Tag"}
      handleClose={handleClose}
      saveButtonTitle="Save"
      saveBtnLoading={loading}
      saveBtnDisabled={!tagName.trim()}
      saveCallback={onChangeSubmit}
      size="sm"
    >
      <Box sx={{ p: 0, m: 0, width: "100%" }}>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <UITextField
            type={"text"}
            name={"tagName"}
            value={tagName || ""}
            title={"Tag Name"}
            maxLength={200}
            postfix={`${tagName.length}/200`}
            onChange={(e) => setTagName(e.target.value.replace(/\s+/g, "_"))}
            onKeyDown={(e) => {
              if (e.key === "Enter" && e.target.value) onChangeSubmit();
            }}
          />
        </FormControl>
        <ColorPicker
          title={"Color"}
          name={"tagColor"}
          value={tagColor}
          onChange={(e) => setTagColor(e.target.value)}
          options={colorOptions}
        />
      </Box>
    </BasicModal>
  );
};

export default AddTagModal;
